import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import Link from '@material-ui/core/Link';
import WarningIcon from '@material-ui/icons/Warning';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CloudDownload from '@material-ui/icons/CloudDownload';
import CloudUpload from '@material-ui/icons/CloudUpload';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import BlockIcon from '@material-ui/icons/Block';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import 'moment/locale/pt-br';
import moment from 'moment';
import { instanceAxios } from '../../InstanceAxios';
import { formatMoney } from '../../utils/common';
import { MSG_ERRO } from '../../consts/common';
import DropZone from '../../components/DropZone';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    width: '95%',
    height: '20%',
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    top: `50%`,
    left: `50%`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    transform: `translate(-50%, -50%)`,
    width: '40%',
    height: '40%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
  button: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

function Faturamento() {
  const classes = useStyles();
  const [ready, setReady] = useState(false);
  const [faturas, setFaturas] = useState([]);
  const [valorTotal, setValorTotal] = useState(0);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');
  const [tipo, setTipo] = useState('TODOS');
  const [columns, setColumns] = useState([
    { id: 'usuario', label: 'Usúario', minWidth: 140 },
    { id: 'origem', label: 'Origem', minWidth: 80 },
    { id: 'parcela', label: 'Parcela', minWidth: 40 },
    { id: 'numero_parcela', label: 'total de Parcela', minWidth: 40 },
    { id: 'valor_pago_parcela', label: 'Valor Pago Por Parcela', minWidth: 70 },
    { id: 'valor_tarifa', label: 'Tarifas', minWidth: 70 },
    { id: 'valor', label: 'Valor Recebido', minWidth: 70 },
    { id: 'data_liberacao', label: 'Data Liberação', minWidth: 140 },
    { id: 'created_at', label: 'Data Pagamento', minWidth: 140 },
    { id: 'notas', label: 'Nota', minWidth: 70 },
    { id: 'emitir', label: 'Emitir Nota', minWidth: 140 },
  ]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [mes, setMes] = useState(moment().subtract(0, 'month').format('MM'));
  const [ano, setAno] = useState(
    mes === '12' ? moment().subtract(1, 'year').year() : moment().year()
  );
  const [meses, setMeses] = useState([
    { nome: 'JAN', valor: '01' },
    { nome: 'FEV', valor: '02' },
    { nome: 'MAR', valor: '03' },
    { nome: 'ABR', valor: '04' },
    { nome: 'MAI', valor: '05' },
    { nome: 'JUN', valor: '06' },
    { nome: 'JUL', valor: '07' },
    { nome: 'AGO', valor: '08' },
    { nome: 'SET', valor: '09' },
    { nome: 'OUT', valor: '10' },
    { nome: 'NOV', valor: '11' },
    { nome: 'DEZ', valor: '12' },
  ]);
  const [anos, setAnos] = useState([
    { nome: '2019', valor: '2019' },
    { nome: '2020', valor: '2020' },
    { nome: '2021', valor: '2021' },
    { nome: '2022', valor: '2022' },
    { nome: '2023', valor: '2023' },
  ]);
  const [modalAddFile, setModalAddFile] = useState(false);

  useEffect(() => {
    fetchFaturas(mes, ano, page, limit, tipo);
  }, [ano, limit, mes, page, tipo]);

  const clickAlert = () => {
    setAlert(false);
    setAlertType('');
    setMessage('');
  };

  const fetchFaturas = async (m, a, p, l, t) => {
    setReady(false);
    console.log(`/faturas?data=${a}-${m}-01&limit=${l}&page=${p}&tipo=${t}`);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/faturas?data=${a}-${m}-01&limit=${l}&page=${p}&tipo=${t}`)
      .then((res) => {
        const rows = Array.isArray(res?.data?.faturas?.rows)
          ? res.data.faturas.rows
          : [];

        console.log(rows);
        setFaturas(rows);
        setCount(res?.data?.faturas?.count || 0);
        setValorTotal(res?.data?.valor || 0);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setMessage('Erro ao atualizar Pagamentos,tente novamente mais tarde!');
        setAlertType('error');
        setAlert(true);
        setReady(true);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchFaturas(mes, ano, newPage, limit, tipo);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setLimit(event.target.value);
    fetchFaturas(mes, ano, page, event.target.value, tipo);
  };

  const handleChangeMes = (event) => {
    setMes(event.target.value);
    setPage(0);
    setLimit(10);
    fetchFaturas(event.target.value, ano, 0, 10, tipo);
  };

  const handleChangeAno = (event) => {
    setAno(event.target.value);
    setPage(0);
    setLimit(10);
    fetchFaturas(mes, event.target.value, 0, 10, tipo);
  };

  const handleTipo = (event) => {
    setTipo(event.target.value);
    setPage(0);
    setLimit(10);
    fetchFaturas(mes, ano, 0, 10, event.target.value);
  };

  const handleErrorNota = (p) => {
    let msg;
    if (!p) {
      msg = 'Erro Interno';
    } else if (p.valor === 0) {
      msg = 'Não é possível emitir Nota para valor R$0.00';
    } else if (!p.NfeXmei) {
      msg = 'Fora do Periodo de emisão.Emissão realizada no final do mês!';
    } else if (p.NfeXmei.nfe_status === 'success') {
      msg = 'Aguardando Homologação!';
    } else if (p.NfeXmei.nfe_motivo_status) {
      msg = p.NfeXmei.nfe_motivo_status;
    } else {
      p = 'Erro Ao Emitir Nota';
    }

    setMessage(msg);
    setAlertType('warning');
    setAlert(true);
  };

  const handleEmitirNota = async (id, t) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/emitirNotaXmei?tipo=${t}&id=${id}`)
      .then((res) => {
        setMessage(res.data.message);
        setAlertType(res.data.status);
        setAlert(true);
        setReady(true);
        fetchFaturas(mes, ano, page, limit, tipo);
      })
      .catch((err) => {
        console.log(err);
        setMessage(err.data.message);
        setAlertType('warning');
        setAlert(true);
        setReady(true);
      });
  };

  const checkEmitNote = (p) => {
    if (
      p.NfeXmei &&
      (p.NfeXmei.nfe_status === 'error' || p.NfeXmei.nfe_status === 'Negada') &&
      p.valor !== 0
    )
      return true;
    return false;
  };

  const gerarPlanilha = async () => {
    const idPlanilha = 11;
    const body = {
      dtInicio: moment(`${ano}-${mes}-01`).startOf('month'),
      dtFim: moment(`${ano}-${mes}-01`).endOf('month'),
    };

    setMessage('Planilha sendo gerada,aguarde!');
    setAlertType('warning');
    setAlert(true);
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/gerarplanilhas/${idPlanilha}`, body)
      .then((res) => {
        window.open(res.data.arquivo, '_blank');
        setReady(true);
        setAlert(false);
      })
      .catch((err) => {
        const msg = err.data ? err.data.message : MSG_ERRO;
        setMessage(msg);
        setAlertType('error');
        setAlert(true);
        setReady(true);
      });
  };

  const handleConciliacao = async (file) => {
    if (file[0]) {
      if (file[0].name.includes('.csv')) {
        const data = new FormData();
        data.append('file', file[0]);
        data.append('data', `${ano}-${mes}-01`);
        setModalAddFile(false);
        setReady(false);
        await instanceAxios(localStorage.getItem('toobiauth'))
          .post(`/conciliacaoiugu`, data)
          .then((res) => {
            window.open(res.data.planilha, '_blank');
            setMessage('Planilha gerada com sucesso!');
            setAlertType('success');
            setAlert(true);
            setReady(true);
          })
          .catch((err) => {
            console.log(err);
            setMessage('Erro, ao gerar planilha,tente mais tarde!');
            setAlertType('error');
            setAlert(true);
            setReady(true);
          });
      } else {
        setMessage('Por favor envie um arquivo no formato csv');
        setAlertType('error');
        setAlert(true);
        setModalAddFile(false);
      }
    }
  };

  return (
    <>
      <Paper>
        <Snackbar open={alert} autoHideDuration={6000} onClose={clickAlert}>
          <Alert variant="filled" severity={alertType} onClick={clickAlert}>
            {message}
          </Alert>
        </Snackbar>
        <Collapse in={ready}>
          <Grid
            container
            style={{ paddingLeft: 10, paddingRight: 10, paddingTop: '1%' }}
          >
            <Grid item xs={12}>
              <div align="center">
                <h1>Relatório Financeiro</h1>
              </div>
            </Grid>
            <Grid container>
              <Grid item xs={3}>
                <FormControl variant="outlined">
                  <InputLabel>Tipo</InputLabel>
                  <Select value={tipo} onChange={handleTipo} label="Tipo">
                    <MenuItem value="TODOS">Todos</MenuItem>
                    <MenuItem value="ASSINATURAS">Assinaturas</MenuItem>
                    <MenuItem value="SERVICOS">Serviços</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <div align="center">
                  <div className={classes.button}>
                    <Grid container>
                      <Grid xs={12}>
                        <div align="center">
                          <Button
                            color="primary"
                            startIcon={<CloudDownload />}
                            onClick={gerarPlanilha}
                          >
                            Gerar Planilha
                          </Button>
                          <Button
                            color="primary"
                            startIcon={<CloudUpload />}
                            onClick={() => setModalAddFile(true)}
                          >
                            Conciliação IUGU
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div align="right">
                  <FormControl variant="outlined">
                    <InputLabel>Mês</InputLabel>
                    <Select value={mes} onChange={handleChangeMes} label="Mês">
                      {meses.map((m) => (
                        <MenuItem key={m.nome} value={m.valor}>
                          {m.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel>Ano</InputLabel>
                    <Select value={ano} onChange={handleChangeAno} label="Ano">
                      {anos.map((a) => (
                        <MenuItem key={a.nome} value={a.valor}>
                          {a.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div align="center">
                <h2>Valor Total:{formatMoney(valorTotal / 100)}</h2>
              </div>
            </Grid>
          </Grid>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align="center"
                    style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(Array.isArray(faturas) ? faturas : []).map((f) => (
                <TableRow key={f.id}>
                  <TableCell component="th" scope="row" align="center">
                    {f.PagamentoAssinatura
                      ? f.PagamentoAssinatura.User.nome
                      : f.PagamentoServico.ServicoContratado.Usuario.nome}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {f.PagamentoAssinatura
                      ? 'Assinatura'
                      : f.PagamentoServico.descricao}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {f.parcela}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {f.numero_parcelas}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {formatMoney(f.valor_pago / 100)}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {formatMoney(f.valor_taxas / 100)}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {formatMoney(f.valor / 100)}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {moment(f.data_liberacao).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {moment(f.created_at).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {f.PagamentoAssinatura ? (
                      f.PagamentoAssinatura.NfeXmei &&
                      f.PagamentoAssinatura.NfeXmei.url_pdf_enotas ? (
                        <Link
                          href={f.PagamentoAssinatura.NfeXmei.url_pdf_enotas}
                          target="_blank"
                        >
                          <CloudDownload />
                        </Link>
                      ) : (
                        <IconButton
                          onClick={() => handleErrorNota(f.PagamentoAssinatura)}
                        >
                          <WarningIcon />
                        </IconButton>
                      )
                    ) : f.PagamentoServico &&
                      f.PagamentoServico.NfeXmei &&
                      f.PagamentoServico.NfeXmei.url_pdf_enotas ? (
                      <Link
                        href={f.PagamentoServico.NfeXmei.url_pdf_enotas}
                        target="_blank"
                      >
                        <CloudDownload />
                      </Link>
                    ) : (
                      <IconButton
                        onClick={() => handleErrorNota(f.PagamentoServico)}
                      >
                        <WarningIcon />
                      </IconButton>
                    )}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {f.PagamentoAssinatura ? (
                      checkEmitNote(f.PagamentoAssinatura) ? (
                        <IconButton
                          onClick={() =>
                            handleEmitirNota(
                              f.PagamentoAssinatura.id,
                              'ASSINATURA'
                            )
                          }
                        >
                          <AddCircleIcon />
                        </IconButton>
                      ) : (
                        <BlockIcon />
                      )
                    ) : checkEmitNote(f.PagamentoServico) ? (
                      <IconButton
                        onClick={() =>
                          handleEmitirNota(f.PagamentoServico.id, 'ASSINATURA')
                        }
                      >
                        <AddCircleIcon />
                      </IconButton>
                    ) : (
                      <BlockIcon />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                component="div"
                style={{ backgroundColor: '#FFF' }}
                rowsPerPageOptions={[5, 10, 25]}
                count={count}
                rowsPerPage={limit}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={modalAddFile}
        onClose={() => setModalAddFile(false)}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: 5,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <DropZone handleButtonClick={handleConciliacao} />
        </div>
      </Modal>
    </>
  );
}

export default Faturamento;
